import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormContext } from "../../../context/Context";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import api from "../../../services/api";
import axiosPrivate from "../../../services/axios/axiosPrivate";
import { useHasPermission } from "hooks/useHasPermission";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Select from "react-select";

function RegisterPage() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    clearErrors,
  } = useForm();
  const { serverError, setServerError } = useFormContext();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [selectDobColor, setDobSelectColor] = useState("#d3d3d3");
  const [sourceColor, setSourceColor] = useState("#d3d3d3");
  const [regInputs, setRegInputs] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobNo: "",
  });
  const [customErrorForRegInputs, setCustomErrorForRegInputs] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobNo: "",
  });
  const canView = useHasPermission("Add Candidate-view");
  const canEdit = useHasPermission("Add Candidate-manage");

  // Reset to form UI
  useEffect(() => {
    if (isSubmitted) {
      const timer = setTimeout(() => {
        setIsSubmitted(false);
        navigate("/admin/candidate")
      }, 2000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [isSubmitted]);


  // pattern failure validation
  const handlePatternForRegInputs = (e, pattern, field) => {
    let value = e.target.value;
    // Clear server error when the user starts typing again
    setServerError("");
    clearErrors(field);
    let patternErrorMessage = "";
    if (
      (field === "firstName" ||
        field === "middleName" ||
        field === "lastName") &&
      value &&
      !pattern.test(value)
    ) {
      patternErrorMessage = "No spaces, numbers or special characters are allowed";
    } else if (field === "mobNo") {
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      const partialPattern = /^[6-9]\d{0,9}$/;
      const fullPattern = pattern;
      if (
        (value && !partialPattern.test(value)) ||
        (value.length === 10 && !fullPattern.test(value))
      ) {
        patternErrorMessage = "Please enter a valid 10-digit mobile number";
      }
    }
    setRegInputs((prev) => ({ ...prev, [field]: value }));
    setCustomErrorForRegInputs((prev) => ({
      ...prev,
      [field]: patternErrorMessage,
    }));
    if (!patternErrorMessage) {
      setCustomErrorForRegInputs((prev) => ({ ...prev, [field]: "" }));
      clearErrors(field);
    }
  };

  const handleDobColorChange = (e) => {
    const selectedDobValue = e.target.value;
    setDobSelectColor(selectedDobValue ? "black" : "#d3d3d3");
    clearErrors("dob");
  };

  const handleSourceColorChange = (e) => {
    const selectedSourceValue = e.target.value;
    setSourceColor(selectedSourceValue ? "black" : "#d3d3d3");
  };

  const handleFormSubmit = async (data) => {
    if (!canEdit) {
      alert("You do not have permission to send invite to candidate.");
      return;
    }
    setHasAttemptedSubmit(true);
    const newPayload = {
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobNo,
      dob: data.dob,
      source: data.sourceOfCandidate || "Recruitment Department",
    };
      console.log("payload:", newPayload);
    try {
            console.log("payload:", newPayload);

      const result = await axiosPrivate.post(api.registration, newPayload);
      if (result.data.reason.includes("Link expiry days configuration is required.")) {
        toast.error("Link expiry days configuration is required.", {
          className: "toast-error-custom",
        });
        return;
      }
      if (result?.data?.success === true) {
        const registrationData = {
          ...result.data,
        };
        localStorage.setItem(
          "registrationData",
          JSON.stringify(registrationData)
        );
                    console.log("payload:", newPayload);

        console.log("Candidate created");
        toast.success(`${result.data.reason}`, { className: 'toast-success-custom' });
        reset();
        setRegInputs({ firstName: "", mobNo: "" })
        setServerError("");
        setIsSubmitted(true);
        setDobSelectColor("#d3d3d3");
        setSourceColor("d3d3d3");

      } else {
        toast.error(`${result?.data?.reason}`, {
          className: "toast-error-custom",
        });
      }
    } catch (err) {
      toast.error("server error", { className: "toast-error-custom" });

      if (err.response) {
        const errorMessage = err.response.data;
        if (errorMessage === "User already invited with this email.") {
          toast.error(
            "This email already exist. Please try with a different one.",
            { className: "toast-error-custom" }
          );
        } else {
          toast.error("Something went wrong. Please try again later.", {
            className: "toast-error-custom",
          });
          setIsSubmitted(false);
        }
      } else if (err.request) {
        toast.error(
          "No response from server. Please check the network connection.",
          { className: "toast-error-custom" }
        );
      } else {
        toast.error("Unable to connect to server", {
          className: "toast-error-custom",
        });
      }
    }
  };

  if (!canView) return null;
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const maxDateString = yesterday.toISOString().split("T")[0];
  return (
    <div className="container-fluid">
      <Breadcrumb />
      {isSubmitted ? (
        <div className="expiredLink">
          <h2 className="expiredLinkHeading">Registration Successful</h2>
          <p className="expiredLinkPara">
            Account activation url has been sent to the registered email id.
          </p>

        </div>


      ) : (
        <div className="register-container">
          <div className="row Signup-row">
            <div className="col-6 left">
              <div className="Signup-form">
                <div className="title">
                  <p className="name">New Candidate Form</p>
                </div>
                <br />
                <div className="form">
                  <form onSubmit={handleSubmit(handleFormSubmit)}>
                    <div>
                      <div className="input-text">
                        <p>
                          First Name <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="text"
                            placeholder="Enter the First Name"
                            {...register("firstName", {
                              required: "Please enter the first name",
                              maxLength: {
                                value: 20,
                                message: "Name cannot exceed 20 characters",
                              },
                              minLength: {
                                value: 2,
                                message: "Name must be at least 2 characters",
                              },
                            })}
                            value={regInputs.firstName}
                            onChange={(e) =>
                              handlePatternForRegInputs(
                                e,
                                /^[A-Za-z]+$/,
                                "firstName"
                              )
                            }
                          />
                          {errors.firstName && (
                            <div className="userErrorMessage">
                              {errors.firstName.message}
                            </div>
                          )}
                          {customErrorForRegInputs.firstName && (
                            <div className="userErrorMessage">
                              {customErrorForRegInputs.firstName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <p>Middle Name</p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="text"
                            placeholder="Enter the middle name"
                            {...register("middleName", {
                              maxLength: {
                                value: 20,
                                message: "Name cannot exceed 20 characters",
                              },
                              minLength: {
                                value: 2,
                                message: "Name must be at least 2 characters",
                              },
                            })}
                            value={regInputs.middleName}
                            onChange={(e) =>
                              handlePatternForRegInputs(
                                e,
                                /^[A-Za-z\s]+$/,
                                "middleName"
                              )
                            }
                          />
                          {errors.middleName && (
                            <div className="userErrorMessage">
                              {errors.middleName.message}
                            </div>
                          )}
                          {customErrorForRegInputs.middleName && (
                            <div className="userErrorMessage">
                              {customErrorForRegInputs.middleName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <p>Last Name <span style={{ color: "red" }}>*</span></p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="text"
                            placeholder="Enter the last name"
                            {...register("lastName", {
                              required: "Please enter the Last name",
                              maxLength: {
                                value: 20,
                                message: "Name cannot exceed 20 characters",
                              },
                              minLength: {
                                value: 2,
                                message: "Name must be at least 2 characters",
                              },
                            })}
                            value={regInputs.lastName}
                            onChange={(e) =>
                              handlePatternForRegInputs(
                                e,
                                /^[A-Za-z\s]+$/,
                                "lastName"
                              )
                            }
                          />
                          {errors.lastName && (
                            <div className="userErrorMessage">
                              {errors.lastName.message}
                            </div>
                          )}
                          {customErrorForRegInputs.lastName && (
                            <div className="userErrorMessage">
                              {customErrorForRegInputs.lastName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <p>
                          E-mail Address <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="email"
                            placeholder="Enter the e-mail address"
                            name="email"
                            {...register("email", {
                              required: "Please enter the email id",
                              pattern: {
                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                message: "Please enter a valid email address",
                              },
                            })}
                          />
                          {errors.email && (
                            <div className="userErrorMessage">
                              {errors.email.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <p>
                          Mobile Number <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="tel"
                            placeholder="Enter the mobile no."
                            {...register("mobNo", {
                              required: "Please enter the mobile no.",
                              minLength: {
                                value: 10,
                                message: "Mobile no. must be of ten digits",
                              },
                            })}
                            value={regInputs.mobNo}
                            onChange={(e) =>
                              handlePatternForRegInputs(
                                e,
                                /^[6-9]\d{9}$/,
                                "mobNo"
                              )
                            }
                          />
                          {errors.mobNo && (
                            <div className="userErrorMessage">
                              {errors.mobNo.message}
                            </div>
                          )}
                          {customErrorForRegInputs.mobNo && (
                            <div className="userErrorMessage">
                              {customErrorForRegInputs.mobNo}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <p>
                          Date Of Birth <span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="user-input-icons">
                          <input
                            className="input-field"
                            type="date"
                            max={maxDateString}
                            placeholder="Enter the DOB in DD/MM/YYYY"
                            {...register("dob", {
                              required: "Please enter the date of birth",
                              validate: (value) => {
                                const selectedDate = new Date(value);
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                return selectedDate < today || "Date of Birth must be in the past";
                              }
                            })}
                            onChange={handleDobColorChange}
                            style={{ color: selectDobColor }}
                          />
                          {errors.dob && (
                            <div className="userErrorMessage">
                              {errors.dob.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="input-text">
                        <label htmlFor="sourceOfCandidate" className="source-label">
                          Source Of Candidate
                        </label>
                        <select className="custom-dropdown"
                          id="sourceOfCandidate"
                          style={{ color: sourceColor }}
                          {...register("sourceOfCandidate", {
                            onChange: (e) => handleSourceColorChange(e)
                          })}>
                          <option value="" hidden > Select the source of candidate
                          </option>
                          <option style={{ color: "black" }}>Referral</option>
                          <option style={{ color: "black" }}>Recruitment Department</option>
                        </select>
                      </div>
                      <br />
                      <div style={{ textAlign: "center" }}>
                        <button
                          className="primary-btn"
                          type="submit" title={
                            canEdit
                              ? "send invite to candidate"
                              : "No permission to send invite to candidate"
                          } style={{
                            opacity: canEdit ? 1 : 0.5, width: "90px", fontSize: "17px"
                          }}
                          disabled={!canEdit}
                        >
                          Submit
                        </button>
                      </div>
                      {hasAttemptedSubmit && serverError && (
                        <div className="serverErrorMessage">{serverError}</div>
                      )}
                      <br />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
      )}
      <ToastContainer />
    </div>
  );
}

export default RegisterPage;
